import loadYoutubeAPI from '../utils/loadYoutubeAPI';
import { toArray } from '../utils/toArray';

function loadVideo(node) {
  return () => {
    let iframe = document.createElement('iframe');
    const embedId = node.dataset.id;
    const start = node.dataset.start;
    let embedSrc = `https://www.youtube.com/embed/${embedId}?rel=0&showinfo=0&autohide=1&modestbranding=1&enablejsapi=1${
      start ? `&t=${start}` : ``
    }`;
    iframe.id = `youtube__video__${embedId}`;

    if (node.dataset.nocontrols) embedSrc += '&controls=0';
    if (node.dataset.noloop) embedSrc += '&loop=0';

    iframe.className = 'video__video';
    iframe.setAttribute('src', embedSrc);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');

    node.innerHTML = '';
    node.appendChild(iframe);

    let player = new YT.Player(iframe.id, {
      events: {
        onReady: function(e) {
          window.players[embedId] = e.target;
          pauseAllVideosExceptTarget(embedId);
          e.target.playVideo();
        },
        onStateChange: function(e) {
          if (e.data == YT.PlayerState.PLAYING) {
            pauseAllVideosExceptTarget(e.target.getVideoData().video_id);
            node.classList.remove('loading');
            node.classList.add('loaded');
            node.classList.remove('paused');
            node.classList.add('playing');
          } else if (e.data == YT.PlayerState.PAUSED) {
            node.classList.remove('playing');
            node.classList.add('paused');
          } else if (e.data == YT.PlayerState.ENDED) {
            node.classList.remove('playing');
          }
        }
      }
    });
  };
}

function pauseAllVideosExceptTarget(targetVideoID) {
  for (let key in window.players) {
    if (!window.players.hasOwnProperty(key)) continue;
    if (key != targetVideoID) window.players[key].pauseVideo();
  }
}

export default () => {
  const youtubeVideos = toArray(document.querySelectorAll('.js-youtube'));

  if (!youtubeVideos.length) return;
  loadYoutubeAPI();
  window.players = {};

  window.onYouTubePlayerAPIReady = () => {
    youtubeVideos.forEach(node => {
      node.addEventListener('click', () => loadVideo(node));
    });
  };
};



// WEBPACK FOOTER //
// ./assets/scripts/components/youtube.js